// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import CreateStore from './store/store'
import axios from '@/plugin/axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui'
import constant from './common/js/constant'
import 'element-ui/lib/theme-chalk/index.css'
import './common/scss/index.scss'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import VueKindEditor from 'vue-kindeditor'
// 引用node_modules中的kindeditor by li.xue 2021/3/24
// import 'kindeditor/kindeditor-all-min.js'
// import 'kindeditor/themes/default/default.css'
// 引用本地static中的kindeditor by li.xue 2021/3/24
import '../static/kindeditor/themes/default/default.css'
import '../static/kindeditor/kindeditor-all-min.js'
import '../static/kindeditor/lang/zh-CN'

import LightTimeline from 'vue-light-timeline'
import 'loaders.css/loaders.min.css'
import utils from './common/js/utils'
import uploader from 'vue-simple-uploader';


Vue.use(uploader);
Vue.use(utils);
Vue.use(VueKindEditor)

Vue.use(LightTimeline)

Vue.config.productionTip = false
Vue.config.devtools = true;
Vue.use(ElementUI);
Vue.use(VueAxios, axios);
Vue.use(Vuex);
Vue.use(iView);
const store = CreateStore();

Vue.prototype.$http.defaults.withCredentials = true;
//axios请求
Vue.prototype.$axios = axios;
Vue.prototype.CONSTANT = constant;

//路由拦截
router.beforeEach((to, from, next) => {
  /**如果用户需要跳转登录页或者跳转不需要验证的页面，直接next() by li.xue 2019/1/25 */
  if (to.path !== '/' && to.matched.some(m => m.meta.auth)) {
    if (localStorage.isLogin === 'TRUE') {
      next();
    } else {
      //  Message.error('您还未登录，请登陆');
      next();
      // next({path: '/'});
    }
  } else if (to.path == '/') {
    next({path: '/home'});
  }else {
    next();
  }
});

//plot:window.wrapHandshake =
window.wrapHandshake =new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js